/* eslint-disable */
import React from "react";

const Vespalogo = () => {
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
	 width="100%" viewBox="0 0 614 320" enable-background="new 0 0 614 320" >
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M418.000000,321.000000 
	C278.666656,321.000000 139.833328,321.000000 1.000000,321.000000 
	C1.000000,214.333328 1.000000,107.666664 1.000000,1.000000 
	C205.666672,1.000000 410.333344,1.000000 615.000000,1.000000 
	C615.000000,107.666664 615.000000,214.333328 615.000000,321.000000 
	C549.500000,321.000000 484.000000,321.000000 418.000000,321.000000 
M150.998871,204.950378 
	C154.666428,204.204041 158.508911,203.926147 161.972168,202.632767 
	C179.865082,195.950409 191.966766,183.309647 195.873230,164.692627 
	C203.276352,129.411560 175.468643,101.366035 145.486023,101.387695 
	C130.163910,101.398758 114.841774,101.370796 99.519646,101.361145 
	C98.853424,101.360725 97.979897,101.096100 97.558235,101.418800 
	C96.041801,102.579346 94.677902,103.939209 93.256355,105.223747 
	C94.706192,106.399979 96.067444,108.429039 97.622673,108.590584 
	C102.071976,109.052757 106.601288,108.699310 111.096252,108.797989 
	C112.277428,108.823921 113.448135,109.326859 115.611404,109.849281 
	C110.225578,114.564857 107.252617,120.482231 99.258087,119.438026 
	C93.036171,118.625359 86.621262,119.314018 80.292343,119.285904 
	C77.496239,119.273483 75.286278,119.796936 75.356194,123.310036 
	C75.424385,126.736389 77.809029,126.742966 80.228699,126.745445 
	C86.349464,126.751709 92.470238,126.747520 100.015839,126.747520 
	C90.588074,146.110916 90.613808,164.612305 102.214592,183.203644 
	C97.006920,183.485504 92.655014,183.721039 88.402824,183.951172 
	C87.167786,190.842407 88.201698,192.087646 94.623787,192.090744 
	C99.285851,192.092987 103.994499,191.808929 108.589851,192.387421 
	C110.817307,192.667831 112.832352,194.635513 114.943565,195.839310 
	C114.701279,196.411499 114.458984,196.983704 114.216698,197.555893 
	C112.254677,197.555893 110.292648,197.552017 108.330635,197.556534 
	C99.003937,197.577972 89.674370,197.492859 80.353539,197.738602 
	C78.907799,197.776718 76.611450,199.098007 76.309113,200.247055 
	C75.952011,201.604248 77.334259,203.419083 78.347847,205.826279 
	C101.593925,205.920258 124.839996,206.023026 148.086166,206.065231 
	C148.773407,206.066467 149.461792,205.430756 150.998871,204.950378 
M223.448593,160.749802 
	C223.004501,161.943604 222.372452,163.102859 222.145859,164.336594 
	C220.225677,174.791306 218.444992,185.271835 216.491592,195.720154 
	C214.717300,205.210327 214.976257,205.570206 224.806076,204.986237 
	C225.111938,204.968048 225.404465,204.725327 225.825943,204.530579 
	C227.244705,196.885834 228.677078,189.167648 230.381287,179.984802 
	C232.114471,185.849457 233.412979,190.243271 234.663483,194.474640 
	C240.275879,195.939575 244.096863,194.444351 246.372299,189.096268 
	C247.349625,186.799286 249.163986,184.858444 250.598053,182.755798 
	C250.965622,182.920029 251.333191,183.084259 251.700745,183.248489 
	C250.500916,190.405884 249.301086,197.563278 248.061462,204.957977 
	C251.938400,204.957977 255.222717,204.957977 258.992188,204.957977 
	C261.577515,190.236526 264.140015,175.644806 266.656952,161.312744 
	C258.743896,158.930511 253.586929,161.205109 250.070801,168.336105 
	C247.811005,172.919189 244.366821,176.918274 240.906525,181.979141 
	C239.356918,177.254303 238.136536,173.701904 237.026260,170.115417 
	C234.088501,160.625565 234.107483,160.619690 223.448593,160.749802 
M435.105774,176.523651 
	C433.985657,182.895050 433.039825,189.303757 431.685852,195.625076 
	C430.739563,200.043182 431.730927,203.335022 435.931885,205.641846 
	C435.157837,206.369751 434.460022,207.065796 433.720551,207.714371 
	C430.756348,210.314178 428.994629,213.457443 430.410461,217.397430 
	C431.880676,221.488800 435.224670,222.954605 439.442719,223.103745 
	C447.869629,223.401627 454.854370,219.781158 457.142670,211.515930 
	C460.385986,199.801163 462.210083,187.693481 464.699402,175.465271 
	C460.596985,175.465271 457.485931,175.465271 454.153137,175.465271 
	C453.119019,181.326096 451.997864,187.031265 451.141754,192.775909 
	C450.629822,196.211227 448.470856,197.219604 445.529388,197.058350 
	C441.859467,196.857147 442.633942,193.940002 442.908478,191.810745 
	C443.601562,186.435547 444.588379,181.098221 445.576660,175.011703 
	C441.813080,175.261581 438.578979,175.476303 435.105774,176.523651 
M286.509521,116.877487 
	C281.543152,114.384720 276.759888,115.377319 271.588959,118.316208 
	C272.723419,111.579079 273.735168,105.570618 274.764160,99.459778 
	C271.234711,99.459778 267.850586,99.459778 264.522705,99.459778 
	C261.770538,115.069550 259.082092,130.317825 256.396759,145.548370 
	C260.214233,145.548370 263.450867,145.548370 266.618561,145.548370 
	C267.734650,139.492981 268.442291,133.678833 270.052673,128.126511 
	C270.532318,126.472878 273.543732,125.553566 275.395111,124.297791 
	C276.264465,125.950279 277.813416,127.588043 277.849640,129.258591 
	C277.909271,132.009628 276.492889,134.806259 276.626892,137.538147 
	C276.754120,140.131485 277.424927,144.239853 279.005188,144.889847 
	C282.021606,146.130600 286.037140,146.050797 289.266907,145.165482 
	C290.734528,144.763214 291.317505,141.133759 292.743805,137.995697 
	C287.139648,138.844360 287.084930,136.430466 287.781921,133.373398 
	C288.297333,131.112823 289.051208,128.779999 288.912781,126.527672 
	C288.721283,123.411652 287.791321,120.341011 286.509521,116.877487 
M333.014282,194.363510 
	C333.129120,193.879684 333.246643,193.396469 333.358429,192.911942 
	C336.538696,179.131027 334.675629,176.458557 320.798340,175.029358 
	C318.014648,174.742676 317.695374,173.272293 318.247620,170.863068 
	C319.186859,166.765701 319.871521,162.609985 320.703430,158.268539 
	C316.816406,158.268539 313.529907,158.268539 310.044281,158.268539 
	C307.786530,170.936996 305.448334,183.440979 303.391266,195.991043 
	C302.806091,199.561203 304.602417,202.308044 307.860901,204.151672 
	C317.147278,209.405777 328.803162,205.271759 333.014282,194.363510 
M360.697113,129.714859 
	C365.337555,129.714859 369.977997,129.714859 374.811523,129.714859 
	C375.329620,126.386780 375.797516,123.381027 376.330627,119.956436 
	C370.566315,119.956436 365.458588,119.956436 360.013702,119.956436 
	C360.634369,116.708946 361.179749,113.855339 361.774048,110.745865 
	C368.688477,110.745865 375.143219,110.745865 381.635162,110.745865 
	C382.122894,107.505852 382.558075,104.614922 383.032959,101.460197 
	C372.618591,101.460197 362.679688,101.460197 352.347504,101.460197 
	C349.749939,116.187271 347.170929,130.809280 344.546783,145.687103 
	C348.657745,145.687103 352.223022,145.687103 355.605835,145.687103 
	C356.404724,140.932404 357.072021,136.495529 357.954742,132.101929 
	C358.130463,131.227234 359.130493,130.518158 360.697113,129.714859 
M231.203217,112.261642 
	C229.328522,123.330109 227.453812,134.398575 225.562637,145.564209 
	C229.378983,145.564209 232.946930,145.564209 236.476624,145.564209 
	C238.542572,133.847733 240.550781,122.458694 242.582993,110.933517 
	C247.807693,110.933517 252.612015,110.933517 257.730469,110.933517 
	C258.289246,107.768501 258.819916,104.762817 259.401062,101.471237 
	C245.437576,101.471237 231.879059,101.471237 217.987076,101.471237 
	C217.442291,104.538017 216.909500,107.537216 216.358627,110.638176 
	C221.514008,110.886147 226.289032,111.115822 231.203217,112.261642 
M411.577209,130.291931 
	C412.339203,125.764687 413.101166,121.237450 413.878845,116.616898 
	C410.243073,116.616898 407.015564,116.616898 403.657318,116.616898 
	C402.562927,122.633514 401.867004,128.438416 400.278015,133.987579 
	C399.802277,135.649033 396.832489,136.596313 395.005310,137.870804 
	C394.133942,136.057724 392.405090,134.171890 392.551636,132.445190 
	C392.996124,127.207954 394.166382,122.032310 395.108063,116.515717 
	C391.478516,116.515717 388.381317,116.515717 384.801483,116.515717 
	C383.564636,123.889542 382.062927,131.208038 381.191864,138.600845 
	C380.595245,143.664536 383.304077,146.814438 388.405762,146.563950 
	C392.455688,146.365082 396.428497,144.596207 400.856293,143.411880 
	C402.884613,146.649216 406.595337,147.431885 411.268616,146.092484 
	C415.645935,144.837921 414.696960,141.573105 414.749878,138.325546 
	C413.471069,138.156586 412.249664,137.995193 410.585449,137.775299 
	C410.871826,135.352524 411.120270,133.250412 411.577209,130.291931 
M427.101837,182.929825 
	C427.518372,180.534988 427.934937,178.140152 428.465942,175.087372 
	C422.596985,175.087372 417.243011,175.087372 411.629303,175.087372 
	C412.093018,171.629578 412.473022,168.796295 412.925415,165.423019 
	C409.671295,166.749481 406.964172,167.597153 404.537964,168.948898 
	C403.308289,169.633987 402.008301,171.107407 401.729309,172.432663 
	C400.162262,179.876923 398.727386,187.359100 397.593628,194.880524 
	C396.954163,199.122772 398.557526,202.717117 402.595612,204.734253 
	C413.444458,210.153625 425.865509,203.311035 427.185974,191.228180 
	C423.902649,191.228180 420.619354,191.228180 417.545532,191.228180 
	C417.022461,192.398560 416.861877,193.652649 416.166443,194.133987 
	C414.543427,195.257355 412.663330,196.009323 410.887360,196.911728 
	C410.201050,195.240829 409.015228,193.590546 408.945251,191.894211 
	C408.839539,189.331482 409.511810,186.736664 409.915283,183.688522 
	C415.770691,183.688522 421.230804,183.688522 427.101837,182.929825 
M455.041901,128.233124 
	C454.457733,131.500854 453.671234,134.747971 453.335510,138.041031 
	C452.794128,143.351654 455.318909,146.790573 460.578522,146.538330 
	C464.731934,146.339157 468.802979,144.422226 473.120544,143.209183 
	C474.958710,146.836853 478.689911,147.303696 483.178375,146.184677 
	C487.807770,145.030533 487.076172,141.731827 486.636353,138.047226 
	C482.069489,139.056854 482.594330,136.192017 483.103943,133.348969 
	C484.091583,127.838997 485.086548,122.330338 486.136230,116.500526 
	C482.481964,116.500526 479.384644,116.500526 475.828003,116.500526 
	C474.893677,121.899429 473.888794,127.254471 473.063385,132.637024 
	C472.528503,136.125092 470.870758,138.361282 467.162964,137.795654 
	C463.449829,137.229187 464.433899,134.244598 464.778198,131.854675 
	C465.503784,126.817879 466.350739,121.798569 467.193115,116.487183 
	C463.534271,116.487183 460.439819,116.487183 457.129456,116.487183 
	C456.447876,120.202858 455.790161,123.788544 455.041901,128.233124 
M430.689697,133.368652 
	C431.111237,130.642700 431.532806,127.916756 431.996094,124.920792 
	C437.851044,124.920792 443.303955,124.920792 448.884064,124.920792 
	C449.317963,122.002113 449.704651,119.401108 450.179749,116.205505 
	C444.498199,116.205505 439.241089,116.205505 433.721161,116.205505 
	C434.184082,112.530785 434.574646,109.430565 435.006866,105.999565 
	C431.879547,107.286865 429.244202,107.982430 427.075012,109.394180 
	C425.490448,110.425461 423.782318,112.239746 423.404999,113.981369 
	C421.932495,120.777908 420.585754,127.651726 419.993011,134.565460 
	C419.737732,137.542908 420.493500,141.627792 422.432220,143.571609 
	C427.281647,148.433838 433.673615,147.703705 439.645630,145.566727 
	C445.147369,143.598007 448.652161,137.916718 448.517517,132.039536 
	C445.562622,132.039536 442.601990,132.039536 441.112091,132.039536 
	C438.050995,134.518555 435.973267,136.332397 433.672607,137.795792 
	C433.502899,137.903717 431.726837,135.486160 430.689697,133.368652 
M298.888062,182.120880 
	C298.468445,181.064880 298.233734,179.878647 297.597504,178.975189 
	C294.675568,174.826019 286.331421,173.357635 279.161407,175.624146 
	C270.869812,178.245209 264.630585,193.360352 268.926575,201.024338 
	C269.867493,202.702927 271.932556,204.348312 273.783295,204.820877 
	C284.074890,207.448685 297.016724,206.538483 298.147766,190.850922 
	C298.337341,188.221237 298.668701,185.601807 298.888062,182.120880 
M534.261047,137.017838 
	C534.086365,135.095566 533.911682,133.173279 533.754028,131.438675 
	C540.289062,131.438675 546.332520,131.438675 552.466797,131.438675 
	C557.430420,119.440521 548.885498,113.182640 537.009216,115.569603 
	C535.876343,115.797302 534.723999,115.994682 533.635437,116.366486 
	C525.629456,119.101067 519.542603,135.104919 523.756042,142.376785 
	C524.235535,143.204346 524.918091,144.014450 525.700012,144.550461 
	C531.027588,148.202423 542.637573,147.513092 547.270203,142.949036 
	C549.157471,141.089630 550.220093,138.393158 551.657898,136.077515 
	C551.160522,135.472626 550.663147,134.867752 550.165771,134.262863 
	C546.654968,135.414246 543.181641,136.707687 539.615479,137.649231 
	C538.125549,138.042603 536.438232,137.688202 534.261047,137.017838 
M301.689331,146.048737 
	C313.509735,148.863022 323.956787,144.109360 323.645508,135.133926 
	C319.577789,135.595383 315.098389,133.386902 311.638336,137.658279 
	C311.139801,138.273712 308.446320,138.007797 307.618530,137.237000 
	C306.540375,136.233047 306.311340,134.317200 305.394989,131.968826 
	C312.707458,131.968826 318.940704,131.968826 325.404785,131.968826 
	C325.673645,129.172501 326.017426,126.877426 326.088318,124.573959 
	C326.209106,120.648659 324.330780,117.902733 320.697906,116.441345 
	C309.374329,111.886253 297.956940,118.324020 296.207153,130.219971 
	C295.965393,131.863800 295.761047,133.515381 295.450378,135.146439 
	C294.496765,140.152985 295.708557,144.042099 301.689331,146.048737 
M373.714050,200.235031 
	C373.338837,199.177689 372.927948,197.191727 372.593811,197.204559 
	C368.613373,197.357437 369.475861,194.978027 369.893616,192.613785 
	C371.897339,181.273529 373.840973,169.922668 375.853821,158.299133 
	C372.260773,158.299133 368.983978,158.299133 365.167084,158.299133 
	C362.818298,171.679718 360.329041,185.068832 358.194733,198.514297 
	C357.574982,202.418442 359.717255,205.173203 363.817871,205.927765 
	C368.340698,206.760010 372.483826,204.692474 373.714050,200.235031 
M502.905670,132.673050 
	C503.150635,131.537018 503.533966,130.410553 503.613251,129.263062 
	C503.808960,126.431396 505.016205,123.895454 507.951599,124.575203 
	C509.332214,124.894897 510.071320,127.985023 511.358673,130.278610 
	C514.083679,129.775497 518.774231,132.551331 520.397034,126.620697 
	C521.357788,123.109489 521.821411,119.733330 518.504944,117.141670 
	C515.069885,114.457329 510.739990,115.059441 505.354828,118.866043 
	C503.998047,115.886574 501.847504,115.469444 495.383881,116.988678 
	C493.732819,126.474014 492.072937,136.010117 490.404449,145.595688 
	C494.188507,145.595688 497.440430,145.595688 500.628906,145.595688 
	C501.408417,141.371826 502.131439,137.454132 502.905670,132.673050 
M338.977539,195.648041 
	C338.221497,203.052185 339.823853,205.667755 345.311920,205.987839 
	C352.117523,206.384766 353.932281,204.607452 353.853760,197.507629 
	C352.553955,197.174850 351.223206,196.834137 349.572052,196.411392 
	C350.802612,189.228439 351.984680,182.328445 353.178436,175.360199 
	C349.125732,175.360199 345.721100,175.360199 342.444214,175.360199 
	C341.266449,182.050217 340.149780,188.393295 338.977539,195.648041 
M387.237488,205.953049 
	C392.866669,205.558197 393.913605,202.231140 392.651703,197.290237 
	C391.497681,197.091446 390.261871,196.878571 388.684204,196.606812 
	C389.300446,192.955048 389.879639,189.553528 390.447296,186.150101 
	C391.035095,182.626022 391.611694,179.100113 392.274628,175.081482 
	C389.212219,175.081482 386.726044,174.839096 384.325867,175.188187 
	C383.199402,175.352036 381.511169,176.510315 381.320435,177.466019 
	C380.031006,183.925903 378.795654,190.421967 378.085968,196.965240 
	C377.328888,203.945084 379.280090,205.793182 387.237488,205.953049 
M356.012543,164.200943 
	C356.003174,161.685837 357.064880,158.545303 353.167267,157.973694 
	C349.911499,157.496231 346.084778,157.163300 344.796722,160.982010 
	C344.030975,163.252167 344.134491,167.524109 345.470734,168.389694 
	C347.419098,169.651779 350.887085,168.969009 353.584534,168.462326 
	C354.566589,168.277863 355.197083,166.221725 356.012543,164.200943 
M394.944977,164.625534 
	C395.582214,161.223114 395.519684,158.210724 390.956818,157.942551 
	C387.363617,157.731369 384.233734,158.714249 383.285187,162.559921 
	C382.677734,165.022751 382.159088,167.921768 385.593903,169.213181 
	C389.366943,170.631744 392.292084,169.514389 394.513824,166.272171 
	C394.693176,166.010468 394.750763,165.665344 394.944977,164.625534 
z"/>
<path fill="#DC3D58" opacity="1.000000" stroke="none" 
	d="
M77.962471,205.035522 
	C77.334259,203.419083 75.952011,201.604248 76.309113,200.247055 
	C76.611450,199.098007 78.907799,197.776718 80.353539,197.738602 
	C89.674370,197.492859 99.003937,197.577972 108.330635,197.556534 
	C110.292648,197.552017 112.254677,197.555893 114.216698,197.555893 
	C114.458984,196.983704 114.701279,196.411499 114.943565,195.839310 
	C112.832352,194.635513 110.817307,192.667831 108.589851,192.387421 
	C103.994499,191.808929 99.285851,192.092987 94.623787,192.090744 
	C88.201698,192.087646 87.167786,190.842407 88.402824,183.951172 
	C92.655014,183.721039 97.006920,183.485504 102.214592,183.203644 
	C90.613808,164.612305 90.588074,146.110916 100.015839,126.747520 
	C92.470238,126.747520 86.349464,126.751709 80.228699,126.745445 
	C77.809029,126.742966 75.424385,126.736389 75.356194,123.310036 
	C75.286278,119.796936 77.496239,119.273483 80.292343,119.285904 
	C86.621262,119.314018 93.036171,118.625359 99.258087,119.438026 
	C107.252617,120.482231 110.225578,114.564857 115.611404,109.849281 
	C113.448135,109.326859 112.277428,108.823921 111.096252,108.797989 
	C106.601288,108.699310 102.071976,109.052757 97.622673,108.590584 
	C96.067444,108.429039 94.706192,106.399979 93.256355,105.223747 
	C94.677902,103.939209 96.041801,102.579346 97.558235,101.418800 
	C97.979897,101.096100 98.853424,101.360725 99.519646,101.361145 
	C114.841774,101.370796 130.163910,101.398758 145.486023,101.387695 
	C175.468643,101.366035 203.276352,129.411560 195.873230,164.692627 
	C191.966766,183.309647 179.865082,195.950409 161.972168,202.632767 
	C158.508911,203.926147 154.666428,204.204041 150.098083,204.979767 
	C125.452362,205.017944 101.707420,205.026733 77.962471,205.035522 
M100.932152,157.294708 
	C101.623611,160.679321 101.945015,164.192551 103.069275,167.426712 
	C108.534851,183.149643 119.453850,193.649582 135.685684,196.769211 
	C151.052811,199.722641 165.853821,196.450424 176.891098,184.545731 
	C188.304169,172.235718 192.242371,157.413361 187.489441,140.853348 
	C183.097443,125.550850 172.380646,116.356430 157.961166,111.119156 
	C148.956863,107.848709 139.315872,108.254471 130.735260,111.471283 
	C113.524567,117.923439 98.876282,134.161301 100.932152,157.294708 
z"/>
<path fill="#080808" opacity="1.000000" stroke="none" 
	d="
M223.864960,160.704193 
	C234.107483,160.619690 234.088501,160.625565 237.026260,170.115417 
	C238.136536,173.701904 239.356918,177.254303 240.906525,181.979141 
	C244.366821,176.918274 247.811005,172.919189 250.070801,168.336105 
	C253.586929,161.205109 258.743896,158.930511 266.656952,161.312744 
	C264.140015,175.644806 261.577515,190.236526 258.992188,204.957977 
	C255.222717,204.957977 251.938400,204.957977 248.061462,204.957977 
	C249.301086,197.563278 250.500916,190.405884 251.700745,183.248489 
	C251.333191,183.084259 250.965622,182.920029 250.598053,182.755798 
	C249.163986,184.858444 247.349625,186.799286 246.372299,189.096268 
	C244.096863,194.444351 240.275879,195.939575 234.663483,194.474640 
	C233.412979,190.243271 232.114471,185.849457 230.381287,179.984802 
	C228.677078,189.167648 227.244705,196.885834 225.825943,204.530579 
	C225.404465,204.725327 225.111938,204.968048 224.806076,204.986237 
	C214.976257,205.570206 214.717300,205.210327 216.491592,195.720154 
	C218.444992,185.271835 220.225677,174.791306 222.145859,164.336594 
	C222.372452,163.102859 223.004501,161.943604 223.864960,160.704193 
z"/>
<path fill="#090909" opacity="1.000000" stroke="none" 
	d="
M435.225342,176.107330 
	C438.578979,175.476303 441.813080,175.261581 445.576660,175.011703 
	C444.588379,181.098221 443.601562,186.435547 442.908478,191.810745 
	C442.633942,193.940002 441.859467,196.857147 445.529388,197.058350 
	C448.470856,197.219604 450.629822,196.211227 451.141754,192.775909 
	C451.997864,187.031265 453.119019,181.326096 454.153137,175.465271 
	C457.485931,175.465271 460.596985,175.465271 464.699402,175.465271 
	C462.210083,187.693481 460.385986,199.801163 457.142670,211.515930 
	C454.854370,219.781158 447.869629,223.401627 439.442719,223.103745 
	C435.224670,222.954605 431.880676,221.488800 430.410461,217.397430 
	C428.994629,213.457443 430.756348,210.314178 433.720551,207.714371 
	C434.460022,207.065796 435.157837,206.369751 435.931885,205.641846 
	C431.730927,203.335022 430.739563,200.043182 431.685852,195.625076 
	C433.039825,189.303757 433.985657,182.895050 435.225342,176.107330 
z"/>
<path fill="#0B0B0B" opacity="1.000000" stroke="none" 
	d="
M286.843567,117.064209 
	C287.791321,120.341011 288.721283,123.411652 288.912781,126.527672 
	C289.051208,128.779999 288.297333,131.112823 287.781921,133.373398 
	C287.084930,136.430466 287.139648,138.844360 292.743805,137.995697 
	C291.317505,141.133759 290.734528,144.763214 289.266907,145.165482 
	C286.037140,146.050797 282.021606,146.130600 279.005188,144.889847 
	C277.424927,144.239853 276.754120,140.131485 276.626892,137.538147 
	C276.492889,134.806259 277.909271,132.009628 277.849640,129.258591 
	C277.813416,127.588043 276.264465,125.950279 275.395111,124.297791 
	C273.543732,125.553566 270.532318,126.472878 270.052673,128.126511 
	C268.442291,133.678833 267.734650,139.492981 266.618561,145.548370 
	C263.450867,145.548370 260.214233,145.548370 256.396759,145.548370 
	C259.082092,130.317825 261.770538,115.069550 264.522705,99.459778 
	C267.850586,99.459778 271.234711,99.459778 274.764160,99.459778 
	C273.735168,105.570618 272.723419,111.579079 271.588959,118.316208 
	C276.759888,115.377319 281.543152,114.384720 286.843567,117.064209 
z"/>
<path fill="#090909" opacity="1.000000" stroke="none" 
	d="
M332.977264,194.763733 
	C328.803162,205.271759 317.147278,209.405777 307.860901,204.151672 
	C304.602417,202.308044 302.806091,199.561203 303.391266,195.991043 
	C305.448334,183.440979 307.786530,170.936996 310.044281,158.268539 
	C313.529907,158.268539 316.816406,158.268539 320.703430,158.268539 
	C319.871521,162.609985 319.186859,166.765701 318.247620,170.863068 
	C317.695374,173.272293 318.014648,174.742676 320.798340,175.029358 
	C334.675629,176.458557 336.538696,179.131027 333.358429,192.911942 
	C333.246643,193.396469 333.129120,193.879684 332.977264,194.763733 
M314.141510,194.457138 
	C316.233002,197.895630 320.084961,198.162384 322.032104,194.736359 
	C323.044525,192.955124 323.674011,190.647003 323.558502,188.629425 
	C323.461945,186.942017 322.413391,184.443329 321.106903,183.880096 
	C318.748901,182.863541 316.134186,183.450867 315.547791,186.841995 
	C315.154755,189.115021 314.716278,191.380203 314.141510,194.457138 
z"/>
<path fill="#0D0D0D" opacity="1.000000" stroke="none" 
	d="
M360.223755,129.723785 
	C359.130493,130.518158 358.130463,131.227234 357.954742,132.101929 
	C357.072021,136.495529 356.404724,140.932404 355.605835,145.687103 
	C352.223022,145.687103 348.657745,145.687103 344.546783,145.687103 
	C347.170929,130.809280 349.749939,116.187271 352.347504,101.460197 
	C362.679688,101.460197 372.618591,101.460197 383.032959,101.460197 
	C382.558075,104.614922 382.122894,107.505852 381.635162,110.745865 
	C375.143219,110.745865 368.688477,110.745865 361.774048,110.745865 
	C361.179749,113.855339 360.634369,116.708946 360.013702,119.956436 
	C365.458588,119.956436 370.566315,119.956436 376.330627,119.956436 
	C375.797516,123.381027 375.329620,126.386780 374.811523,129.714859 
	C369.977997,129.714859 365.337555,129.714859 360.223755,129.723785 
z"/>
<path fill="#0D0D0D" opacity="1.000000" stroke="none" 
	d="
M231.133636,111.803574 
	C226.289032,111.115822 221.514008,110.886147 216.358627,110.638176 
	C216.909500,107.537216 217.442291,104.538017 217.987076,101.471237 
	C231.879059,101.471237 245.437576,101.471237 259.401062,101.471237 
	C258.819916,104.762817 258.289246,107.768501 257.730469,110.933517 
	C252.612015,110.933517 247.807693,110.933517 242.582993,110.933517 
	C240.550781,122.458694 238.542572,133.847733 236.476624,145.564209 
	C232.946930,145.564209 229.378983,145.564209 225.562637,145.564209 
	C227.453812,134.398575 229.328522,123.330109 231.133636,111.803574 
z"/>
<path fill="#0E0E0E" opacity="1.000000" stroke="none" 
	d="
M411.472961,130.720108 
	C411.120270,133.250412 410.871826,135.352524 410.585449,137.775299 
	C412.249664,137.995193 413.471069,138.156586 414.749878,138.325546 
	C414.696960,141.573105 415.645935,144.837921 411.268616,146.092484 
	C406.595337,147.431885 402.884613,146.649216 400.856293,143.411880 
	C396.428497,144.596207 392.455688,146.365082 388.405762,146.563950 
	C383.304077,146.814438 380.595245,143.664536 381.191864,138.600845 
	C382.062927,131.208038 383.564636,123.889542 384.801483,116.515717 
	C388.381317,116.515717 391.478516,116.515717 395.108063,116.515717 
	C394.166382,122.032310 392.996124,127.207954 392.551636,132.445190 
	C392.405090,134.171890 394.133942,136.057724 395.005310,137.870789 
	C396.832489,136.596313 399.802277,135.649033 400.278015,133.987579 
	C401.867004,128.438416 402.562927,122.633514 403.657318,116.616898 
	C407.015564,116.616898 410.243073,116.616898 413.878845,116.616898 
	C413.101166,121.237450 412.339203,125.764687 411.472961,130.720108 
z"/>
<path fill="#0B0B0B" opacity="1.000000" stroke="none" 
	d="
M426.896362,183.309174 
	C421.230804,183.688522 415.770691,183.688522 409.915283,183.688522 
	C409.511810,186.736664 408.839539,189.331482 408.945251,191.894211 
	C409.015228,193.590546 410.201050,195.240829 410.887360,196.911713 
	C412.663330,196.009323 414.543427,195.257355 416.166443,194.133987 
	C416.861877,193.652649 417.022461,192.398560 417.545532,191.228180 
	C420.619354,191.228180 423.902649,191.228180 427.188446,191.233765 
	C425.865509,203.311035 413.444458,210.153625 402.595612,204.734253 
	C398.557526,202.717117 396.954163,199.122772 397.593628,194.880524 
	C398.727386,187.359100 400.162262,179.876923 401.729309,172.432663 
	C402.008301,171.107407 403.308289,169.633987 404.537964,168.948898 
	C406.964172,167.597153 409.671295,166.749481 412.925415,165.423019 
	C412.473022,168.796295 412.093018,171.629578 411.629303,175.087372 
	C417.243011,175.087372 422.596985,175.087372 428.465942,175.087372 
	C427.934937,178.140152 427.518372,180.534988 426.896362,183.309174 
z"/>
<path fill="#0D0D0E" opacity="1.000000" stroke="none" 
	d="
M455.087158,127.803680 
	C455.790161,123.788544 456.447876,120.202858 457.129456,116.487183 
	C460.439819,116.487183 463.534271,116.487183 467.193115,116.487183 
	C466.350739,121.798569 465.503784,126.817879 464.778198,131.854675 
	C464.433899,134.244598 463.449829,137.229187 467.162964,137.795654 
	C470.870758,138.361282 472.528503,136.125092 473.063385,132.637024 
	C473.888794,127.254471 474.893677,121.899429 475.828003,116.500526 
	C479.384644,116.500526 482.481964,116.500526 486.136230,116.500526 
	C485.086548,122.330338 484.091583,127.838997 483.103943,133.348969 
	C482.594330,136.192017 482.069489,139.056854 486.636353,138.047226 
	C487.076172,141.731827 487.807770,145.030533 483.178375,146.184677 
	C478.689911,147.303696 474.958710,146.836853 473.120544,143.209183 
	C468.802979,144.422226 464.731934,146.339157 460.578522,146.538330 
	C455.318909,146.790573 452.794128,143.351654 453.335510,138.041031 
	C453.671234,134.747971 454.457733,131.500854 455.087158,127.803680 
z"/>
<path fill="#0B0B0B" opacity="1.000000" stroke="none" 
	d="
M430.693665,133.805695 
	C431.726837,135.486160 433.502899,137.903717 433.672607,137.795792 
	C435.973267,136.332397 438.050995,134.518555 441.112091,132.039536 
	C442.601990,132.039536 445.562622,132.039536 448.517517,132.039536 
	C448.652161,137.916718 445.147369,143.598007 439.645630,145.566727 
	C433.673615,147.703705 427.281647,148.433838 422.432220,143.571609 
	C420.493500,141.627792 419.737732,137.542908 419.993011,134.565460 
	C420.585754,127.651726 421.932495,120.777908 423.404999,113.981369 
	C423.782318,112.239746 425.490448,110.425461 427.075012,109.394180 
	C429.244202,107.982430 431.879547,107.286865 435.006866,105.999565 
	C434.574646,109.430565 434.184082,112.530785 433.721161,116.205505 
	C439.241089,116.205505 444.498199,116.205505 450.179749,116.205505 
	C449.704651,119.401108 449.317963,122.002113 448.884064,124.920792 
	C443.303955,124.920792 437.851044,124.920792 431.996094,124.920792 
	C431.532806,127.916756 431.111237,130.642700 430.693665,133.805695 
z"/>
<path fill="#0B0B0C" opacity="1.000000" stroke="none" 
	d="
M298.911285,182.549255 
	C298.668701,185.601807 298.337341,188.221237 298.147766,190.850922 
	C297.016724,206.538483 284.074890,207.448685 273.783295,204.820877 
	C271.932556,204.348312 269.867493,202.702927 268.926575,201.024338 
	C264.630585,193.360352 270.869812,178.245209 279.161407,175.624146 
	C286.331421,173.357635 294.675568,174.826019 297.597504,178.975189 
	C298.233734,179.878647 298.468445,181.064880 298.911285,182.549255 
M281.031891,184.548294 
	C280.336731,186.548065 279.329987,188.501663 279.025085,190.559265 
	C278.642151,193.143616 277.345520,196.577286 281.539764,197.345825 
	C285.222107,198.020554 286.862305,195.537430 287.612457,192.332367 
	C287.874512,191.212799 288.113312,190.076416 288.222168,188.934296 
	C288.756989,183.324219 287.245636,182.206009 281.031891,184.548294 
z"/>
<path fill="#101010" opacity="1.000000" stroke="none" 
	d="
M534.550842,137.345825 
	C536.438232,137.688202 538.125549,138.042603 539.615479,137.649231 
	C543.181641,136.707687 546.654968,135.414246 550.165771,134.262863 
	C550.663147,134.867752 551.160522,135.472626 551.657898,136.077515 
	C550.220093,138.393158 549.157471,141.089630 547.270203,142.949036 
	C542.637573,147.513092 531.027588,148.202423 525.700012,144.550461 
	C524.918091,144.014450 524.235535,143.204346 523.756042,142.376785 
	C519.542603,135.104919 525.629456,119.101067 533.635437,116.366486 
	C534.723999,115.994682 535.876343,115.797302 537.009216,115.569603 
	C548.885498,113.182640 557.430420,119.440521 552.466797,131.438675 
	C546.332520,131.438675 540.289062,131.438675 533.754028,131.438675 
	C533.911682,133.173279 534.086365,135.095566 534.550842,137.345825 
M542.035339,123.983635 
	C538.227112,122.766556 535.701050,123.734764 534.698303,128.394379 
	C536.937195,128.394379 538.747192,128.362854 540.555725,128.401321 
	C543.760742,128.469467 543.768250,126.851578 542.035339,123.983635 
z"/>
<path fill="#0B0B0B" opacity="1.000000" stroke="none" 
	d="
M301.287384,146.000168 
	C295.708557,144.042099 294.496765,140.152985 295.450378,135.146439 
	C295.761047,133.515381 295.965393,131.863800 296.207153,130.219971 
	C297.956940,118.324020 309.374329,111.886253 320.697906,116.441345 
	C324.330780,117.902733 326.209106,120.648659 326.088318,124.573959 
	C326.017426,126.877426 325.673645,129.172501 325.404785,131.968826 
	C318.940704,131.968826 312.707458,131.968826 305.394989,131.968826 
	C306.311340,134.317200 306.540375,136.233047 307.618530,137.237000 
	C308.446320,138.007797 311.139801,138.273712 311.638336,137.658279 
	C315.098389,133.386902 319.577789,135.595383 323.645508,135.133926 
	C323.956787,144.109360 313.509735,148.863022 301.287384,146.000168 
M312.320343,128.396973 
	C313.453125,127.839066 314.585938,127.281151 315.718719,126.723244 
	C314.903015,125.675339 313.844971,123.624977 313.313690,123.753418 
	C311.040619,124.303001 308.922882,125.495102 306.748535,126.452896 
	C306.942230,127.020721 307.135956,127.588539 307.329681,128.156357 
	C308.731720,128.231369 310.133789,128.306381 312.320343,128.396973 
z"/>
<path fill="#090909" opacity="1.000000" stroke="none" 
	d="
M373.707214,200.653107 
	C372.483826,204.692474 368.340698,206.760010 363.817871,205.927765 
	C359.717255,205.173203 357.574982,202.418442 358.194733,198.514297 
	C360.329041,185.068832 362.818298,171.679718 365.167084,158.299133 
	C368.983978,158.299133 372.260773,158.299133 375.853821,158.299133 
	C373.840973,169.922668 371.897339,181.273529 369.893616,192.613785 
	C369.475861,194.978027 368.613373,197.357437 372.593811,197.204559 
	C372.927948,197.191727 373.338837,199.177689 373.707214,200.653107 
z"/>
<path fill="#0D0D0D" opacity="1.000000" stroke="none" 
	d="
M502.880066,133.104736 
	C502.131439,137.454132 501.408417,141.371826 500.628906,145.595688 
	C497.440430,145.595688 494.188507,145.595688 490.404449,145.595688 
	C492.072937,136.010117 493.732819,126.474014 495.383881,116.988678 
	C501.847504,115.469444 503.998047,115.886574 505.354828,118.866043 
	C510.739990,115.059441 515.069885,114.457329 518.504944,117.141670 
	C521.821411,119.733330 521.357788,123.109489 520.397034,126.620697 
	C518.774231,132.551331 514.083679,129.775497 511.358673,130.278610 
	C510.071320,127.985023 509.332214,124.894897 507.951599,124.575203 
	C505.016205,123.895454 503.808960,126.431396 503.613251,129.263062 
	C503.533966,130.410553 503.150635,131.537018 502.880066,133.104736 
z"/>
<path fill="#070707" opacity="1.000000" stroke="none" 
	d="
M339.005310,195.192215 
	C340.149780,188.393295 341.266449,182.050217 342.444214,175.360199 
	C345.721100,175.360199 349.125732,175.360199 353.178436,175.360199 
	C351.984680,182.328445 350.802612,189.228439 349.572052,196.411392 
	C351.223206,196.834137 352.553955,197.174850 353.853760,197.507629 
	C353.932281,204.607452 352.117523,206.384766 345.311920,205.987839 
	C339.823853,205.667755 338.221497,203.052185 339.005310,195.192215 
z"/>
<path fill="#090909" opacity="1.000000" stroke="none" 
	d="
M386.815186,205.968506 
	C379.280090,205.793182 377.328888,203.945084 378.085968,196.965240 
	C378.795654,190.421967 380.031006,183.925903 381.320435,177.466019 
	C381.511169,176.510315 383.199402,175.352036 384.325867,175.188187 
	C386.726044,174.839096 389.212219,175.081482 392.274628,175.081482 
	C391.611694,179.100113 391.035095,182.626022 390.447296,186.150101 
	C389.879639,189.553528 389.300446,192.955048 388.684204,196.606812 
	C390.261871,196.878571 391.497681,197.091446 392.651703,197.290237 
	C393.913605,202.231140 392.866669,205.558197 386.815186,205.968506 
z"/>
<path fill="#070707" opacity="1.000000" stroke="none" 
	d="
M356.000244,164.610229 
	C355.197083,166.221725 354.566589,168.277863 353.584534,168.462326 
	C350.887085,168.969009 347.419098,169.651779 345.470734,168.389694 
	C344.134491,167.524109 344.030975,163.252167 344.796722,160.982010 
	C346.084778,157.163300 349.911499,157.496231 353.167267,157.973694 
	C357.064880,158.545303 356.003174,161.685837 356.000244,164.610229 
z"/>
<path fill="#101010" opacity="1.000000" stroke="none" 
	d="
M394.904968,164.992264 
	C394.750763,165.665344 394.693176,166.010468 394.513824,166.272171 
	C392.292084,169.514389 389.366943,170.631744 385.593903,169.213181 
	C382.159088,167.921768 382.677734,165.022751 383.285187,162.559921 
	C384.233734,158.714249 387.363617,157.731369 390.956818,157.942551 
	C395.519684,158.210724 395.582214,161.223114 394.904968,164.992264 
z"/>
<path fill="#8E3F5E" opacity="1.000000" stroke="none" 
	d="
M78.155159,205.430893 
	C101.707420,205.026733 125.452362,205.017944 149.673477,205.050598 
	C149.461792,205.430756 148.773407,206.066467 148.086166,206.065231 
	C124.839996,206.023026 101.593925,205.920258 78.155159,205.430893 
z"/>
<path fill="#FCFAFB" opacity="1.000000" stroke="none" 
	d="
M100.922363,156.822510 
	C98.876282,134.161301 113.524567,117.923439 130.735260,111.471283 
	C139.315872,108.254471 148.956863,107.848709 157.961166,111.119156 
	C172.380646,116.356430 183.097443,125.550850 187.489441,140.853348 
	C192.242371,157.413361 188.304169,172.235718 176.891098,184.545731 
	C165.853821,196.450424 151.052811,199.722641 135.685684,196.769211 
	C119.453850,193.649582 108.534851,183.149643 103.069275,167.426712 
	C101.945015,164.192551 101.623611,160.679321 100.922363,156.822510 
M153.037170,184.844666 
	C156.997375,182.804291 161.300430,181.232605 164.852448,178.634232 
	C174.852127,171.319214 179.565155,155.606125 176.303421,144.824905 
	C170.832962,126.742996 148.634506,115.474731 131.490829,124.429100 
	C119.749832,130.561584 108.975609,148.112747 114.509247,163.186798 
	C119.764061,177.501328 133.754318,189.221008 153.037170,184.844666 
z"/>
<path fill="#F4F4F4" opacity="1.000000" stroke="none" 
	d="
M314.219818,194.053024 
	C314.716278,191.380203 315.154755,189.115021 315.547791,186.841995 
	C316.134186,183.450867 318.748901,182.863541 321.106903,183.880096 
	C322.413391,184.443329 323.461945,186.942017 323.558502,188.629425 
	C323.674011,190.647003 323.044525,192.955124 322.032104,194.736359 
	C320.084961,198.162384 316.233002,197.895630 314.219818,194.053024 
z"/>
<path fill="#F6F6F6" opacity="1.000000" stroke="none" 
	d="
M281.331940,184.275146 
	C287.245636,182.206009 288.756989,183.324219 288.222168,188.934296 
	C288.113312,190.076416 287.874512,191.212799 287.612457,192.332367 
	C286.862305,195.537430 285.222107,198.020554 281.539764,197.345825 
	C277.345520,196.577286 278.642151,193.143616 279.025085,190.559265 
	C279.329987,188.501663 280.336731,186.548065 281.331940,184.275146 
z"/>
<path fill="#F4F4F4" opacity="1.000000" stroke="none" 
	d="
M542.324829,124.285645 
	C543.768250,126.851578 543.760742,128.469467 540.555725,128.401321 
	C538.747192,128.362854 536.937195,128.394379 534.698303,128.394379 
	C535.701050,123.734764 538.227112,122.766556 542.324829,124.285645 
z"/>
<path fill="#EBEAEB" opacity="1.000000" stroke="none" 
	d="
M311.928101,128.389191 
	C310.133789,128.306381 308.731720,128.231369 307.329681,128.156357 
	C307.135956,127.588539 306.942230,127.020721 306.748535,126.452896 
	C308.922882,125.495102 311.040619,124.303001 313.313690,123.753418 
	C313.844971,123.624977 314.903015,125.675339 315.718719,126.723244 
	C314.585938,127.281151 313.453125,127.839066 311.928101,128.389191 
z"/>
<path fill="#D93754" opacity="1.000000" stroke="none" 
	d="
M152.616028,184.869354 
	C133.754318,189.221008 119.764061,177.501328 114.509247,163.186798 
	C108.975609,148.112747 119.749832,130.561584 131.490829,124.429100 
	C148.634506,115.474731 170.832962,126.742996 176.303421,144.824905 
	C179.565155,155.606125 174.852127,171.319214 164.852448,178.634232 
	C161.300430,181.232605 156.997375,182.804291 152.616028,184.869354 
M140.931595,146.429306 
	C140.626404,146.107880 140.321213,145.786453 140.016022,145.465027 
	C139.834747,145.674713 139.653488,145.884384 139.472214,146.094070 
	C139.980255,146.397141 140.488297,146.700211 140.988907,147.620758 
	C140.984512,148.031357 140.980118,148.441971 140.520782,149.415634 
	C140.004166,151.275864 139.487564,153.136108 138.086258,155.001114 
	C135.995361,155.029388 133.904465,155.057663 131.372269,154.589401 
	C130.561157,153.927353 129.750046,153.265305 128.691010,152.308609 
	C128.486923,152.136353 128.252060,152.035950 127.236244,151.941940 
	C125.280251,151.385925 123.324249,150.829910 121.119789,150.203262 
	C120.158241,158.451279 121.770859,164.937988 128.091415,170.322540 
	C129.232819,168.715683 130.037796,167.499283 130.929504,166.350204 
	C131.837494,165.180130 132.830872,164.076309 134.427628,162.654831 
	C136.279907,160.771286 138.132202,158.887726 140.647949,157.371948 
	C144.811203,160.136185 148.390411,159.669098 150.294693,156.113022 
	C152.065994,152.805328 150.588013,149.976913 145.394699,147.280945 
	C143.930893,147.186081 142.467102,147.091217 140.931595,146.429306 
M133.220322,145.482559 
	C133.220322,145.482559 133.665207,145.529663 133.665207,145.529663 
	C133.665207,145.529663 133.985977,145.176834 134.556183,144.755981 
	C141.669693,137.412292 142.208588,135.915543 140.006577,129.240326 
	C133.352417,131.976624 126.764229,134.671204 123.876686,142.413513 
	C127.350624,143.480103 130.186249,144.350708 133.220322,145.482559 
M149.712082,167.118912 
	C147.715744,167.112030 145.719406,167.105438 143.723068,167.098206 
	C140.801208,167.087616 134.244461,172.529938 135.357391,174.418915 
	C136.340759,176.088013 139.517410,176.495407 141.758636,177.375977 
	C142.517944,177.674301 143.428894,177.977707 144.183258,177.830750 
	C147.681229,177.149384 151.148529,176.310577 154.626816,175.528137 
	C153.235229,172.838242 151.843658,170.148346 149.712082,167.118912 
M149.106979,130.382889 
	C149.069656,132.201172 148.686127,134.100220 149.086395,135.816437 
	C149.543167,137.774887 150.357956,139.847290 151.610947,141.386948 
	C156.032898,146.820480 160.948761,144.545288 166.121994,141.916962 
	C162.851318,134.425247 156.591980,131.413513 149.106979,130.382889 
M169.067505,155.509796 
	C169.067505,153.898392 169.067505,152.287003 169.067505,149.094131 
	C165.029282,151.262024 160.937866,152.136597 159.241577,154.636414 
	C155.368607,160.344009 157.357040,165.820068 162.705307,170.283951 
	C166.423706,166.425797 168.987015,161.998840 169.067505,155.509796 
M131.436325,149.705811 
	C131.706940,149.990021 131.977539,150.274231 132.248138,150.558441 
	C132.365356,150.445847 132.591003,150.242035 132.584122,150.233841 
	C132.331879,149.934006 132.058029,149.652344 131.436325,149.705811 
z"/>
<path fill="#442745" opacity="1.000000" stroke="none" 
	d="
M133.786865,162.943481 
	C132.830872,164.076309 131.837494,165.180130 130.929504,166.350204 
	C130.037796,167.499283 129.232819,168.715683 128.091415,170.322540 
	C121.770859,164.937988 120.158241,158.451279 121.119789,150.203262 
	C123.324249,150.829910 125.280251,151.385925 127.701096,152.165482 
	C128.165955,152.389023 128.519836,152.613846 128.519836,152.613846 
	C128.519836,152.613846 128.938934,152.603256 128.938934,152.603256 
	C129.750046,153.265305 130.561157,153.927353 131.598663,155.219543 
	C132.478989,158.214294 133.132935,160.578888 133.786865,162.943481 
z"/>
<path fill="#442849" opacity="1.000000" stroke="none" 
	d="
M150.082092,167.288696 
	C151.843658,170.148346 153.235229,172.838242 154.626801,175.528137 
	C151.148529,176.310577 147.681229,177.149384 144.183258,177.830750 
	C143.428894,177.977707 142.517944,177.674301 141.758636,177.375977 
	C139.517410,176.495407 136.340759,176.088013 135.357391,174.418915 
	C134.244461,172.529938 140.801208,167.087616 143.723068,167.098206 
	C145.719406,167.105438 147.715744,167.112030 150.082092,167.288696 
z"/>
<path fill="#432847" opacity="1.000000" stroke="none" 
	d="
M149.252655,130.017700 
	C156.591980,131.413513 162.851318,134.425247 166.121994,141.916962 
	C160.948761,144.545288 156.032898,146.820480 151.610947,141.386948 
	C150.357956,139.847290 149.543167,137.774887 149.086395,135.816437 
	C148.686127,134.100220 149.069656,132.201172 149.252655,130.017700 
z"/>
<path fill="#442948" opacity="1.000000" stroke="none" 
	d="
M133.021866,145.221313 
	C130.186249,144.350708 127.350624,143.480103 123.876686,142.413513 
	C126.764229,134.671204 133.352417,131.976624 140.006577,129.240326 
	C142.208588,135.915543 141.669693,137.412292 134.028351,144.939087 
	C133.500534,145.122192 133.021866,145.221313 133.021866,145.221313 
z"/>
<path fill="#442849" opacity="1.000000" stroke="none" 
	d="
M169.054657,155.943146 
	C168.987015,161.998840 166.423706,166.425797 162.705307,170.283951 
	C157.357040,165.820068 155.368607,160.344009 159.241577,154.636414 
	C160.937866,152.136597 165.029282,151.262024 169.067505,149.094131 
	C169.067505,152.287003 169.067505,153.898392 169.054657,155.943146 
z"/>
<path fill="#442745" opacity="1.000000" stroke="none" 
	d="
M145.926178,147.753113 
	C150.588013,149.976913 152.065994,152.805328 150.294693,156.113022 
	C148.390411,159.669098 144.811203,160.136185 140.212555,156.926407 
	C139.508408,155.986023 139.239685,155.491180 138.970963,154.996338 
	C139.487564,153.136108 140.004166,151.275864 141.097198,149.030304 
	C143.091141,148.347672 144.508652,148.050385 145.926178,147.753113 
z"/>
<path fill="#C83552" opacity="1.000000" stroke="none" 
	d="
M138.528610,154.998718 
	C139.239685,155.491180 139.508408,155.986023 139.880814,156.742523 
	C138.132202,158.887726 136.279907,160.771286 134.107239,162.799164 
	C133.132935,160.578888 132.478989,158.214294 131.819305,155.467834 
	C133.904465,155.057663 135.995361,155.029388 138.528610,154.998718 
z"/>
<path fill="#C83552" opacity="1.000000" stroke="none" 
	d="
M145.660431,147.517029 
	C144.508652,148.050385 143.091141,148.347672 141.324661,148.748764 
	C140.980118,148.441971 140.984512,148.031357 140.994446,147.310379 
	C141.000000,147.000000 141.003296,146.996338 141.003296,146.996338 
	C142.467102,147.091217 143.930893,147.186081 145.660431,147.517029 
z"/>
<path fill="#C83552" opacity="1.000000" stroke="none" 
	d="
M131.611740,149.536987 
	C132.058029,149.652344 132.331879,149.934006 132.584122,150.233841 
	C132.591003,150.242035 132.365356,150.445847 132.248138,150.558441 
	C131.977539,150.274231 131.706940,149.990021 131.611740,149.536987 
z"/>
<path fill="#C83552" opacity="1.000000" stroke="none" 
	d="
M140.998169,147.001648 
	C140.488297,146.700211 139.980255,146.397141 139.472214,146.094070 
	C139.653488,145.884384 139.834747,145.674713 140.016022,145.465027 
	C140.321213,145.786453 140.626404,146.107880 140.967438,146.712830 
	C141.003296,146.996338 141.000000,147.000000 140.998169,147.001648 
z"/>
<path fill="#C83552" opacity="1.000000" stroke="none" 
	d="
M128.814972,152.455933 
	C128.938934,152.603256 128.519836,152.613846 128.519836,152.613846 
	C128.519836,152.613846 128.165955,152.389023 128.076202,152.198196 
	C128.252060,152.035950 128.486923,152.136353 128.814972,152.455933 
z"/>
<path fill="#C83552" opacity="1.000000" stroke="none" 
	d="
M133.121094,145.351929 
	C133.021866,145.221313 133.500534,145.122192 133.743256,145.149506 
	C133.985977,145.176834 133.665207,145.529663 133.665207,145.529663 
	C133.665207,145.529663 133.220322,145.482559 133.121094,145.351929 
z"/>
</svg>
	);
}

export default Vespalogo;
